
/*
 *   File : kyc-submission.js
 *   Author URI : https://evoqins.com
 *   Description : KYC Submission success pop up
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect } from "react";

import { GradientButton, SecondaryButton } from "../Cta";

import style from "../../Styles/Components/kyc-submission.module.scss"

const KYCSubmissionModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("kyc-submission");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close()
        });
    }, []);

    return (
        <div className={`modal fade ${style.e_submission_modal}`}
            id="kyc-submission"
            tabIndex="-1"
            aria-labelledby="kyc-submission"
            aria-hidden="true"
            data-bs-backdrop={props.type === 2 ? "static" : "true"} >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                {
                    props.type === 2 ?
                        <div className={`modal-content bg-modal padding-32px-all text-center ${style.e_content} `}>
                            <div className="text-center">
                                <img src={require("../../Assets/Images/Profile/sign_up.svg").default}
                                    alt="Delete SIP"
                                    width={72}
                                    height={72} />
                            </div>
                            <h5 className="mb-0 e-poppins-medium e-font-16 line-height-16px color-light-black mt-3">
                                KYC Verification Successful
                            </h5>
                            <p className="color-eerie-black e-poppins-regular e-font-18 mb-0 mt-4">
                                Your KYC verification has been successfully completed.
                            </p>
                            <div className="margin-40px-top row justify-content-center gap-8px">

                                <div className="col-8">
                                    <GradientButton label="Continue"
                                        cancel="modal"
                                        className="e-font-16 px-3 padding-12px-tb w-100"
                                        onPress={()=> props.continue()} />
                                </div>

                            </div>
                        </div>
                        :
                        <div className={`modal-content bg-modal padding-32px-lr text-center pb-3 ${style.e_content} `}>
                            <div className="text-center">
                                <img src={require("../../Assets/Images/Profile/sign_up.svg").default}
                                    alt="Delete SIP"
                                    width={72}
                                    height={72} />
                            </div>
                            <p className="color-eerie-black e-poppins-medium e-font-18 mb-2 mt-4">
                                Your account created successfully. You can start investing now.
                            </p>
                            <div className="mt-4 d-flex justify-content-center gap-8px px-5">
                                <SecondaryButton label="Cancel"
                                    cancel="modal"
                                    className="e-font-16 e-poppins-regular px-4 padding-12px-tb" />
                                <GradientButton label="Invest now"
                                    cancel="modal"
                                    className="e-font-16 px-3 padding-12px-tb w-100" />

                            </div>
                        </div>
                }
            </div>
        </div>
    )
};

export default KYCSubmissionModal